import { Grid, Typography } from '@mui/material';
import DialogModal from 'components/modal/dialog-modal';
import ActionButton from 'components/buttons';

interface IDeletePermanentlyModal {
  open: boolean;
  allFiles?: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeletePermanentlyModal = ({
  open,
  allFiles,
  isLoading,
  onConfirm,
  onClose,
}: IDeletePermanentlyModal) => {
  return (
    <DialogModal open={open} maxWidth="670px" withCloseButton={false} handleClose={onClose}>
      <Grid container sx={{ mb: '10px' }} alignItems="center">
        <Typography
          sx={styles.title}
        >{`Permanently delete ${allFiles ? 'all items' : 'this item'}?`}</Typography>
      </Grid>
      <Typography
        sx={styles.text}
      >{`${allFiles ? 'All items' : 'This item'} in Trash will be permanently deleted and cannot be recovered.`}</Typography>
      <Grid container justifyContent="flex-end" sx={{ mt: '20px' }} gap={2}>
        <ActionButton variant="secondary" onClick={onClose} label="Cancel" />
        <ActionButton onClick={onConfirm} loading={isLoading} label="Delete" />
      </Grid>
    </DialogModal>
  );
};

export const styles = {
  title: {
    fontSize: '24px',
    lineHeight: '20px',
    fontWeight: 400,
    color: '#23252F',
    fontFamily: 'Inter, sans-serif !important',
    whiteSpace: 'nowrap',
  },

  text: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: '#6E707A',
  },
};
